<template>
  <v-expansion-panels class="mb-4">
    <v-expansion-panel>
      <v-expansion-panel-header class="font-weight-bold">
        <template v-slot:default>
          <v-row no-gutters>
            <v-col cols="auto" class="mr-2">
              <v-icon color="info">mdi-information</v-icon>
            </v-col>
            <v-col class="d-flex align-center">
              Hälytysmuonituksen toimintaohje
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="pt-4">
        <div class="text-body-2">
          <p>
            Tikestä tulee tekstiviesti muonitusryhmän jäsenille
            hälytysmuonitukseen. Jotta voimme varmistaa, että hälytys tavoittaa
            ryhmän jäsenet, emäntä, osastonjohtaja tai osaston varajohtaja
            (varalla Leirikosken talonmies) tekee vielä secapp-hälytyksen.
            Kaikki kuittaavat osallistumisensa secapp-hälytykseen.
            Secapp-keskustelun kautta sovitaan toimenpiteet ja jaetaan
            tarvittavat ohjeet.
          </p>

          <h3 class="text-subtitle-1 font-weight-bold mt-2">
            Asemalta mukaan:
          </h3>
          <ul class="mb-2">
            <li>
              Muonituslaatikot; joissa on mukit, jätesäkit, käsidesi ja muut
              tarvikkeet
            </li>
            <li>Kanisterit mehulle, vedelle ja käsienpesuun.</li>
            <li>Termarit kahville ja teevedelle.</li>
            <li>
              Tarpeen mukaan kylmä/lämpölaatikot (1-2kpl) ja taittopöydät
              (1-2kpl).
            </li>
            <li>
              Harkinnan mukaan peräkärryyn punainen telttakatos tai
              ilmakaariteltat (kokoonpano tarvitsee miesten apua, sovitaan
              erikseen koska otetaan mukaan)
            </li>
            <li>Pimeään aikaan valaistus mukaan.</li>
            <li>Muonitukseen tarvittava vaatetus.</li>
          </ul>

          <h3 class="text-subtitle-1 font-weight-bold mt-2">
            Ensimmäisen aallon muonitus: (valmiina n. 1-2h hälytyksestä)
          </h3>
          <p>
            Kahvi/tee, kerrosleipä, mehu ja juomavesi (tarvikkeet haetaan
            lähikaupasta tai Tikkulan Smarkettia, valmistetaan asemalla tai
            mahdollisuuksien mukaan paikan päällä) tai vaihtoehtoisesti:
          </p>
          <ol type="a" class="mb-2 ml-4">
            <li>käytetään aseman pakastimen sisältöä (jos on riittävästi)</li>
            <li>
              Yöaikaan: Kaikki valmistaa kotona leipiä + kahvia niin paljon kuin
              saa, asemalta muut tarvikkeet sekä kanisterit (jos kauppa matkan
              varrella sieltä maito ja muut puuttuvat)
            </li>
            <li>
              otetaan grilli ja kaasupullo (Leirikoskelta) sekä kaupasta
              makkaraa. Lisäksi asemalta makkarapussit sekä kanisterit mehua ja
              vettä varten.
            </li>
          </ol>
          <p>
            Suunnittelussa huomioitava ajankohta sekä mahdollisuus käydä
            kaupassa. Muonituksen päätyttyä tarvikkeiden pesu, huolto sekä
            täydennys. Laskutushinta 6,5€/hlö.
          </p>

          <h3 class="text-subtitle-1 font-weight-bold mt-2">
            Toisen aallon muonitus: (valmiina n. 2-3h hälytyksestä)
          </h3>
          <p>
            Tarvittaessa valmistetaan ruoka pitkäkestoisiin hälytyksiin.
            Valitaan helposti/nopeasti valmistettavaa sekä lusikalla syötävää
            ruokaa. Käytetään lähikauppaa tai Tikkulan S-markettia. Ennen kuin
            uusi keittiö käytössä pyritään valmistamaan Leirikoskella tai
            tarvittaessa muonittajien kotona. Muonituksen päätyttyä tarvikkeiden
            pesu, huolto sekä täydennys.
          </p>

          <h3 class="text-subtitle-1 font-weight-bold mt-2">Huomioitavaa:</h3>
          <ul class="mb-2">
            <li>Muista käsihygienia.</li>
            <li>Tilannepaikalle lähtee vain tarvittava määrä muonittajia.</li>
            <li>
              Suojaudu (kertakäyttöessu, -myssy, -käsineet ja -maski) tarpeen ja
              ohjeistusten mukaan.
            </li>
            <li>
              Leivät kelmuun tai pakattava muuten annoksiksi (esim. pussi)
            </li>
            <li>
              Jos jakelija paikalla, tarjottavat tarjolle niin, että on helppoa
              ja hygieenistä ottaa:
              <ul>
                <li>leivät laatikosta helpommin otettavaksi</li>
                <li>
                  kahvi/tee ja mehu mukiin tarjolle tarvittaessa valmiiksi
                </li>
              </ul>
            </li>
            <li>
              Tilannepaikalle saavuttaessa kartoitetaan tilanne Tikestä tai
              tilannepaikan johtajalta:
              <ul>
                <li>Muonituspisteen sijoituspaikka</li>
                <li>
                  Jätetäänkö tarvikkeet tilannepaikalle vai jäädäänkö
                  muonittamaan/jakeluun
                </li>
                <li>Lupa muonituksen aloitukseen</li>
                <li>Käsidesi tai puhdistuspyyhkeet muonitettaville</li>
                <li>Asiallinen jätehuolto</li>
              </ul>
            </li>
          </ul>

          <p class="caption mt-4">
            Tämä hälytysmuonituksen toimintaohje on vahvistettu Noormarkun VPK:n
            hallituksen kokouksessa 22.01.2023 ja astuu voimaan heti.
          </p>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: "MuonitusOhje",
};
</script>
